module.exports = __webpack_public_path__ + "static/media/f5.d5e9406c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/f5.jpg
// module id = 398
// module chunks = 0